import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#FF9800' cx='12' cy='12' r='12' />,
    <circle key='1' fill='#FFFFFF' cx='12' cy='12' r='10' />,
    <path
      key='2'
      fill='#FF9800'
      d='M18,8.6L18,8.6L15.4,6l-0.7,0.7l1.4,1.4C15.4,8.5,15,9.1,15,9.8c0,1,0.8,1.7,1.7,1.7c0.3,0,0.5-0.1,0.7-0.2v5
	c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-3.2c0-0.7-0.6-1.4-1.4-1.4h-0.7V7.1c0-0.7-0.6-1.4-1.4-1.4H8.4C7.7,5.8,7,6.4,7,7.1
	v11.1h7V13h1.1v3.4c0,1,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7V9.9C18.5,9.4,18.3,9,18,8.6z M12.6,10.6H8.4V7.1h4.2V10.6z
	 M16.7,10.6c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7S17.2,10.6,16.7,10.6z'
    />,
  ],
  'TransportConditionGeofenceDrain'
);

const TransportConditionGeofenceDrainIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionGeofenceDrainIcon);
